import { createFileRoute } from '@tanstack/react-router';
import { SheetReviewPage } from '@/features/sync/SheetReviewPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { readSyncSearch, syncSearchSchema, syncViewProps } from '@/features/sync/syncSearch';

// Không dùng `/attendance/review`: đó là "Xem giờ công" (giờ người nộp). Đây là duyệt thay đổi từ bảng chấm công trên Sheet.
export const Route = createFileRoute('/_authenticated/attendance/sheet-review')({
  validateSearch: syncSearchSchema,
  component: function AttendanceSheetReview() {
    const cur = readSyncSearch(Route.useSearch());
    const navigate = Route.useNavigate();
    return (
      <SheetReviewPage
        config={SHEET_TABS.attendance}
        {...syncViewProps(cur, (search) => void navigate({ search, replace: true }))}
      />
    );
  },
});
